module.exports = __webpack_public_path__ + "assets/img/0_686_big.1fdc73e1.jpg";